import { HOST_QUERY_KEY, iamApiInstance, type ServiceAppState } from '@kc-console/context';

import { CookieKeyMap, DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../constants';

import type { GuardParams } from '../types';

const getBrowserLanguage = (acceptLanguageHeader: string | undefined) => {
  const browserLanguage = acceptLanguageHeader?.split(',')[0]?.split('-')[0] || '';
  return SUPPORTED_LANGUAGES.includes(browserLanguage) ? browserLanguage : '';
};

export const getCurrentLanguage = async (props: GuardParams<ServiceAppState>) => {
  const { queryClient, state, context } = props;
  const { req } = context;
  const { token, userId, language: stateLanguage, displayLanguage: stateDisplayLanguage } = state;

  // 이미 가드에서 결정된 언어가 있으면 우선 사용 (Account 호스트 등)
  if (stateLanguage && SUPPORTED_LANGUAGES.includes(stateLanguage)) {
    return {
      language: stateLanguage,
      displayLanguage: stateDisplayLanguage ?? stateLanguage,
    };
  }

  let userLanguage = '';

  if (token && userId) {
    const { fetchUserDetailInfo } = iamApiInstance({ token });

    const { language_code = '' } = await queryClient.fetchQuery({
      queryKey: [HOST_QUERY_KEY.GET_IAM_USER_DETAIL_INFO],
      queryFn: () => fetchUserDetailInfo({ userId }),
    });

    userLanguage = language_code;
  } else {
    const languageByCookie = req.cookies[CookieKeyMap.DISPLAY_LANGUAGE_KEY];
    userLanguage = languageByCookie || '';
  }

  const languageByBrowser = getBrowserLanguage(req?.headers['accept-language']);

  const language = userLanguage || languageByBrowser || DEFAULT_LANGUAGE;

  return { language, displayLanguage: userLanguage };
};
